import React, { useState } from 'react';
import { galleryImages } from '../mockData';

const GalleryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { value: 'all', label: 'All Work' },
    { value: 'detailing', label: 'Auto Detailing' },
    { value: 'interior', label: 'Interior Work' },
    { value: 'service', label: 'Service Bay' }
  ];

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="gallery-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Our Work Gallery</h1>
          <p className="page-subtitle">
            See the quality and attention to detail that sets us apart
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          {/* Category Filter */}
          <div className="gallery-filters">
            {categories.map((category) => (
              <button
                key={category.value}
                onClick={() => setSelectedCategory(category.value)}
                className={`filter-btn ${selectedCategory === category.value ? 'active' : ''}`}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="gallery-grid">
            {filteredImages.map((image) => (
              <div 
                key={image.id} 
                className="gallery-item"
                onClick={() => setSelectedImage(image)}
              >
                <img src={image.url} alt={image.alt} loading="lazy" />
                <div className="gallery-item-overlay">
                  <h3>{image.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="lightbox-close" 
              onClick={() => setSelectedImage(null)}
              aria-label="Close lightbox"
            >
              ×
            </button>
            <img src={selectedImage.url} alt={selectedImage.alt} />
            <div className="lightbox-info">
              <h3>{selectedImage.title}</h3>
              <p>{selectedImage.alt}</p>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="gallery-cta">
        <div className="container">
          <div className="cta-box">
            <h2>Ready for Similar Results?</h2>
            <p>Let us transform your vehicle with the same care and attention to detail</p>
            <a href="tel:6473261174" className="btn-primary btn-large">
              Book Your Service Today
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;
